import authModule from './auth'
import usersModule from './users'
import singleInvoiceModule from './single-invoice'
import clientModule from './client'
import invoicesModule from './invoices'
import timesheetsModule from './timesheets'
import candidateModule from './candidate'
import candidateProfilePictureModule from './candidate-profile-picture'
import fileModule from './file'
import bookingsModule from './bookings'
import contactsModule from './contacts'
import locationsModule from './locations'
import pendingFeedbacksModule from './pending-feedback'
import featuresModule from './features'
import bookingApprovalsModule from './booking-approvals'
import bookingFiltersModule from './booking-filters'

export default {
  bookingApprovals: bookingApprovalsModule,
  bookingFilters: bookingFiltersModule,
  features: featuresModule,
  locations: locationsModule,
  contacts: contactsModule,
  bookings: bookingsModule,
  timesheets: timesheetsModule,
  file: fileModule,
  singleInvoice: singleInvoiceModule,
  client: clientModule,
  invoices: invoicesModule,
  candidate: candidateModule,
  candidateProfilePicture: candidateProfilePictureModule,
  auth: authModule,
  users: usersModule,
  pendingfeedbacks: pendingFeedbacksModule,
}
